import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Diaa Corp - SAP Solutions & Services', 
  description = 'Diaa Corp is a service-based company dedicated to bringing innovations to life with our clients through SAP solutions and services.',
  canonical = 'https://diaacorp.com',
  keywords = 'SAP, ERP, consulting, implementation, migration, enterprise applications',
  image = '/logo.png',
  type = 'website'
}) => {
  const siteUrl = 'https://diaacorp.com';
  const fullImageUrl = `${siteUrl}${image}`;
  
  return (
    <Helmet>
      {/* Basic metadata */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
    </Helmet>
  );
};

export default SEO; 